import { useState, useEffect } from "react";

const STAGING_PASSWORD = import.meta.env.MODE === "staging"
  ? import.meta.env.VITE_STAGING_PASSWORD
  : undefined;
const STORAGE_KEY = "quuil_staging_auth";

export function StagingGate({ children }: { children: React.ReactNode }) {
  const [authenticated, setAuthenticated] = useState(false);
  const [input, setInput] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!STAGING_PASSWORD) {
      setAuthenticated(true);
      return;
    }
    if (sessionStorage.getItem(STORAGE_KEY) === "1") {
      setAuthenticated(true);
    }
  }, []);

  if (authenticated) return <>{children}</>;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (input === STAGING_PASSWORD) {
      sessionStorage.setItem(STORAGE_KEY, "1");
      setAuthenticated(true);
    } else {
      setError(true);
      setInput("");
    }
  };

  return (
    <div className="min-h-screen bg-[#1A1A1A] flex items-center justify-center px-5">
      <form onSubmit={handleSubmit} className="w-full max-w-sm text-center">
        <img
          src="/logo.png"
          alt="Quuil"
          className="h-14 w-auto mx-auto mb-8"
        />
        <p className="text-white/40 text-sm mb-6">
          Staging environment
        </p>
        <input
          type="password"
          value={input}
          onChange={(e) => {
            setInput(e.target.value);
            setError(false);
          }}
          placeholder="Password"
          className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-xl text-white text-sm placeholder:text-white/30 focus:outline-none focus:border-white/40 transition-colors"
        />
        {error && (
          <p className="text-red-400 text-xs mt-2">Incorrect password</p>
        )}
        <button
          type="submit"
          className="w-full mt-4 bg-white text-[#1A1A1A] px-6 py-3 rounded-xl font-medium text-sm hover:bg-white/90 transition-colors"
        >
          Enter
        </button>
      </form>
    </div>
  );
}
